import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { UIService } from '../../services/ui.service';

@Component({
    selector: 'cs-selecao-comunicados',
    templateUrl: './selecao-comunicados.component.html',
    styleUrls: ['./selecao-comunicados.component.scss']
})
export class SelecaoComunicadosComponent implements OnInit {

    constructor(private ui: UIService, public dialogRef: MatDialogRef<SelecaoComunicadosComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
    }
}
